import { useState } from "react";
import { fetchReport } from "../../api/admin";
import { listUsers } from "../../api/directory";
import { usePoll } from "../../hooks/usePoll";

// Local calendar date, so "today" matches the user's midnight, not UTC's.
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

// Today's attendance board: always reads today's records only, optionally for one branch.
export const useTodaySummary = (branchId = "") => {
  const [state, setState] = useState({ summary: null, rows: [], employees: [], date: todayStr() });

  const load = async () => {
    const day = todayStr();
    const [report, staff] = await Promise.all([
      fetchReport({ from_date: day, to_date: day, ...(branchId ? { branch_id: branchId } : {}) }),
      listUsers(branchId || undefined),
    ]);
    setState({ summary: report.summary, rows: report.rows, employees: staff, date: day });
  };

  usePoll(() => load().catch(() => {}), 60000, [branchId]);

  return state;
};
